// import './steps/styles'
// import './steps/polyfill'
// import './steps/error-handling'

import DocumentReady from 'document-ready-promise'

export default DocumentReady
